import {getCurrentYear} from '../../utils/commons'
import BestOutdoorGearPicksLogo from './logo'
import {bestOutdoorGearPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestoutdoorgearpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Outdoor Gear Picks',
  logo: <BestOutdoorGearPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/bestoutdoorgearpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-Q0QQELN921',
    camelCaseUrl: 'BestOutdoorGearPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestOutdoorGearPicks.com – Expert Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover top-rated outdoor gear with expert reviews and buying guides. Get the best equipment for camping, hiking, and adventure in ${getCurrentYear()}.`,
    styles: bestOutdoorGearPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
